export default "__VITE_ASSET__BP2$LMD2__"